import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  fileListContainer: {
    margin: 20,
  },
}));
